export default [
  {
    path: 'my-account',
    component: () => import('@/layouts/GroupLayout'),
    children: [
      {
        path: '',
        component: () => import('@/pages/my-account/Index'),
        name: 'my-account.index',
      },
      {
        path: 'edit-details',
        component: () => import('@/pages/my-account/EditDetails'),
        name: 'my-account.edit-details',
      },
      {
        path: 'change-password',
        component: () => import('@/pages/my-account/ChangePassword'),
        name: 'my-account.change-password',
      },
    ]
  }
];
